// extracted by mini-css-extract-plugin
export default {"wrapper":"Styles_wrapper__9xcT5","header":"Styles_header__VCyFt","form":"Styles_form__+MUiq","form_control":"Styles_form_control__ILHZq"};